import React from 'react';
import DocumentForm from './components/DocumentForm';
import './styles/App.css';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <h1>📄 Document Entry Portal</h1>
        <p>Upload and manage document metadata</p>
      </header>
      <DocumentForm />
    </div>
  );
}

export default App;

